import { useContentfulLiveUpdates } from "@contentful/live-preview/react"
import RenderBlocks from "@lib/renderBlocks"
import FlexibleData from "@lib/flexibleData"
import Layout from "@layout/index"

// ---------------------------------------------------------

export async function getStaticProps(context) {
  const preview = process.env.NODE_ENV === "development" || context.draftMode || false
  const previewEnv = context?.previewData?.environment || null

  const slug = "privacy-policy"
  const data = (await FlexibleData.fetch(slug, preview, previewEnv)) ?? []

  return {
    props: { preview, data }
  }
}

// ---------------------------------------------------------

const PrivacyPolicyPage = ({ data, children, preview, pageTitle, featuredImage, excerpt }) => {
  const liveData = useContentfulLiveUpdates(data)

  const meta = {
    "og:title": pageTitle ? pageTitle : liveData?.title,
    title: pageTitle ? pageTitle : liveData?.title,
    "og:image": featuredImage?.url ? featuredImage.url : liveData?.featuredImage?.url,
    description: excerpt ? excerpt : liveData?.excerpt,
    "og:description": excerpt ? excerpt : liveData?.excerpt,
    robots: liveData?.isPrivate ? "noindex" : "index"
  }

  // ---------------------------------------------------------

  return (
    <Layout preview={preview} customMeta={meta}>
      {liveData?.modulesCollection && RenderBlocks(liveData.modulesCollection.items)}
      {children}
    </Layout>
  )
}

export default PrivacyPolicyPage
